type QueryParams = Record<string, string | number | boolean | undefined | Record<string, unknown>>

const buildBracketedParams = (
  obj: Record<string, unknown>,
  prefix = '',
): Record<string, string> => {
  const result: Record<string, string> = {}

  Object.entries(obj).forEach(([key, value]) => {
    const fullKey = prefix ? `${prefix}[${key}]` : key

    if (value === null || value === undefined || value === false) {
      return
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(
        result,
        buildBracketedParams(value as Record<string, unknown>, fullKey),
      )
    }
    else {
      result[fullKey] = String(value)
    }
  })

  return result
}

export const createSuffix = (queryParams: QueryParams = {}): string => {
  const flatParams = buildBracketedParams(queryParams)
  const urlSearchParams = new URLSearchParams(flatParams)

  const queryString = urlSearchParams.toString()
  return queryString ? `?${queryString}` : ''
}
